import React from 'react';
import { Placeholder } from '../Placeholder/Placeholder';

export const TerritorySectionTitleLoader = () => (
  <Placeholder className="mb-5 w-[200px] h-8 rounded-[27px] animate-pulse bg-t2-neutral-grey03" />
);
